import { Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { GreekWatermark } from "@/components/GreekWatermark";

export function MemberStories() {
  return (
    <section className="py-24 sm:py-32 relative" data-testid="member-stories-section">
      <GreekWatermark letter="Ψ" className="bottom-0 right-0 sm:right-10" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <p className="eyebrow mb-3">Member stories</p>
          <h2 className="font-anton uppercase tracking-tighter text-cream text-4xl sm:text-5xl">Stronger, together.</h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <Reveal className="relative aspect-[4/3] overflow-hidden border border-gold/25" data-testid="member-stories-group-photo">
            <img src="/gallery/community.jpg" alt="Elysium community" className="w-full h-full object-cover" />
          </Reveal>
          <Reveal delay={0.1} className="bg-surface border border-gold/25 p-8 sm:p-10">
            <Quote className="h-8 w-8 text-gold mb-4" />
            <p className="font-accent italic text-cream text-lg sm:text-xl leading-relaxed">
              "Lovely training facility that is clean and well equipped. Knowledgeable coaches that
              genuinely care about helping everyone improve. Classes can be adapted for all abilities.
              The community in the gym is second to none. Everyone is welcoming, encouraging, and
              celebrates each other's success like it's their own."
            </p>
            <p className="text-gold text-sm uppercase tracking-widest mt-6">— Nia, Elysium Member</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
